import { ca } from '@cian/analytics';

import { EFrequency } from '../../../packages/SaveSearchModal';

interface ITrackSubscribedParameters {
  frequency: EFrequency;
  subscribeToNews: boolean;
  title?: string;
  email?: string;
  defaultTitle?: string | null;
  defaultEmail?: string | null;
  offerId: number;
}

enum EFilledEmail {
  /** Равен стандартному емейлу */
  Default = 0,
  /** Введен пользователем */
  Custom = 2,
}

const notificationFrequencyMap: { [key in EFrequency]: string } = {
  [EFrequency.Asap]: 'Asap',
  [EFrequency.Hourly]: 'Hourly',
  [EFrequency.Daily]: 'Daily',
  [EFrequency.Weekly]: 'Weekly',
};

export const trackSubscriptionModalOpen = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'location_subscription',
    action: 'open',
    label: 'window',
    useLastProducts: true,
  });
};

export const trackSubscriptionModalClose = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'location_subscription',
    action: 'close',
    label: 'window',
    useLastProducts: true,
  });
};

export const trackSubscribed = ({
  frequency,
  subscribeToNews,
  title,
  email,
  defaultTitle,
  defaultEmail,
  offerId,
}: ITrackSubscribedParameters) => {
  const filledTitle = title === defaultTitle ? `auto_${defaultTitle}` : title;

  const filledEmail = email === defaultEmail ? EFilledEmail.Default : EFilledEmail.Custom;

  ca('eventSite', {
    name: 'oldevent',
    category: 'location_subscription',
    action: 'show',
    label: 'success',
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
        extra: {
          not_freq: notificationFrequencyMap[frequency],
          not_yes: subscribeToNews ? 1 : 0,
          filled: {
            title: filledTitle,
            email: filledEmail,
          },
        },
      },
    ],
  });
};
